// extracted by mini-css-extract-plugin
export default {"root":"IconPlus_root__xzsZJ","horizontalLine":"IconPlus_horizontalLine__2YooW","verticalLine":"IconPlus_verticalLine__E6qra","lineVerticalOpen":"IconPlus_lineVerticalOpen__-beDH"};